import React from "react";
import '../styles/Contact.css';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom'; // Importar Link para la navegación

function Contact() {
    return (
        <div>
            <h2>Contact Page</h2>

            <h3 style={{ color: "white", display: "none" }}>Misael y Emmanuel</h3>

            <Typography variant="h6" noWrap>
                <Link to="/contact/Misael" style={{ textDecoration: 'none', color: '#aaaaff' }}>
                    <h1>Misael</h1>
                </Link>
            </Typography>

            <Typography variant="h6" noWrap>
                <Link to="/contact/Emmanuel" style={{ textDecoration: 'none', color: '#aaaaff' }}>
                    <h1>Emmanuel</h1>
                </Link>
            </Typography>

            <Typography variant="h6" noWrap>
                <Link to="/contact/Nadie" style={{ textDecoration: 'none', color: '#aaaaff' }}>
                    <h1>Nadie</h1>
                </Link>
            </Typography>

            <h3 style={{ color: "pink" }}>Luisana</h3>
        </div>
    );
}

export default Contact;